import React from 'react';

export default function VideoWalkthrough({ videoId, title = 'Video walkthrough', start = 0 }) {
  const src = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&start=${start}`;

  return (
    <div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
      <iframe
        src={src}
        title={title}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
      />
    </div>
  );
}
